import { render, staticRenderFns } from "./team_lineup.vue?vue&type=template&id=42662456&scoped=true&"
import script from "./team_lineup.vue?vue&type=script&lang=js&"
export * from "./team_lineup.vue?vue&type=script&lang=js&"
import style0 from "./team_lineup.vue?vue&type=style&index=0&id=42662456&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42662456",
  null
  
)

export default component.exports